export class PageNotFound extends Error {
  constructor(message = 'Page not found') {
    super(message);
    // Set explicitly so the name survives minification — the Sentry
    // beforeSend backstop matches on `event.exception.values[].type`
    // (RISKSMART-APP-APY / RISKSMART-APP-A1H, ENG-479).
    this.name = 'PageNotFound';
  }
}

export class Forbidden extends Error {
  constructor(message = 'Access denied') {
    super(message);
    this.name = 'Forbidden';
  }
}
